<section class="section" id="certifications">

 
  <div class="container cert-container">

    <div class="about-title mb-5">
      <h3 class="e-font section-title">
        <span class="code-font n-section-title">03.</span>
        Certifications
      </h3>
    </div>
    <div class="cert-hero">
  <h2>5+ Certifications</h2>
  <p>Professional achievements & verified learning milestones</p>
</div>

    <div class="cert-slider">

      <button class="nav left" (click)="prev()">‹</button>

      <div class="cert-card">

        <img [src]="certifications[active].image" />

        <h4>
          {{ certifications[active].title }}
          <span>{{ certifications[active].date }}</span>
        </h4>

        <p>{{ certifications[active].description }}</p>

        <div class="tags">
          <span *ngFor="let t of certifications[active].tags">
            {{ t }}
          </span>
        </div>

      </div>

      <button class="nav right" (click)="next()">›</button>

    </div>

  </div>
</section>